import React from 'react'
import PropTypes from 'prop-types'

import RemoveIntegration from 'containers/Admin/Integrations/ZendeskSatisfaction/RemoveIntegration'
import { Grid } from 'semantic-ui-react'

const ZendeskSyncManagement = ({ authenticationSettings, companyId }) => (
  <Grid>
    <Grid.Column width={12}>
      <div className="ui success message">
        <div className="header">Integration Active</div>
        <p>
          We'll check your Zendesk account every 30 minutes to import any new satisfaction ratings.
        </p>
      </div>

      <hr />

      <table className="ui collapsing compact celled table">
        <thead>
          <tr>
            <th colSpan={2}>Authentication Settings</th>
          </tr>
        </thead>
        <tr>
          <td>Zendesk subdomain</td>
          <td>
            <code>{authenticationSettings.subdomain}.zendesk.com</code>
          </td>
        </tr>
        <tr>
          <td>Email</td>
          <td>
            <code>{authenticationSettings.email}</code>
          </td>
        </tr>
      </table>
      <RemoveIntegration companyId={companyId} />
    </Grid.Column>
  </Grid>
)

ZendeskSyncManagement.propTypes = {
  authenticationSettings: PropTypes.object,
  companyId: PropTypes.number,
}

export default ZendeskSyncManagement



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Integrations/ZendeskSatisfaction/SyncManagement/index.js